export enum UserSecretTypeEnum {
    QUAL_CERT = 'QUAL_CERT',
    SUKL_IDENTITY = 'SUKL_IDENTITY',
}

export enum UserSecretFormatEnum {
    BASE_AUTH = 'BASE_AUTH',
    TWO_FILES = 'TWO_FILES',
    ONE_FILE = 'ONE_FILE',
}

export const userSecretTypeToFormatMap: Record<UserSecretTypeEnum, UserSecretFormatEnum> = {
    [UserSecretTypeEnum.QUAL_CERT]: UserSecretFormatEnum.TWO_FILES,
    [UserSecretTypeEnum.SUKL_IDENTITY]: UserSecretFormatEnum.BASE_AUTH,
};


